import React from 'react';

function EditableSelectField({
  name,
  value,
  onChange,
  editable,
  options,
  emptyOption = true,
  disabledFallback = 'input',
  editValue = value,
}) {
  if (!editable) {
    if (disabledFallback === 'text') {
      return value;
    }
    return (
      <input
        name={name}
        onChange={onChange}
        className='project-detail-input'
        disabled
        value={value}
      />
    );
  }

  return (
    <select name={name} onChange={onChange} className='edit-input' defaultValue={editValue}>
      {emptyOption ? <option value=''></option> : null}
      {options.map((option) => {
        const optValue = typeof option === 'string' ? option : option.value;
        const optLabel = typeof option === 'string' ? option : option.label;
        return (
          <option key={optValue} value={optValue}>
            {optLabel}
          </option>
        );
      })}
    </select>
  );
}

export default EditableSelectField;
